export default __webpack_public_path__ + "static/media/arrow.fa9f30cf.svg";